// SPDX-License-Identifier: AGPL-3.0-or-later
import Accessibility from '@app/features/accessibility/state/Accessibility';
import Window from '@app/features/window/state/Window';
export function useAutoplayExpandedProfileAnimations(): boolean {
	const windowFocused = Window.focused;
	const windowVisible = Window.visible;
	const prefersReducedMotion = Accessibility.useReducedMotion;
	return windowFocused && windowVisible && !prefersReducedMotion;
}
